export enum BattleflyBattleStatuses {
  Battling = 'Battling',
  Inactive = 'Inactive',
  Unstaked = 'Unstaked',
}
